module.exports = __webpack_public_path__ + "img/tutorial-seleccionado.807d7ca8.png";